(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 42604:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

/**
 * @description A module for parsing ISO8601 durations
 */
__webpack_unused_export__ = ({ value: true });
exports.my = exports.ut = exports.Qc = exports.uj = void 0;
/**
 * The pattern used for parsing ISO8601 duration (PnYnMnWnDTnHnMnS).
 */
// PnYnMnWnDTnHnMnS
var numbers = "\\d+";
var fractionalNumbers = "".concat(numbers, "(?:[\\.,]").concat(numbers, ")?");
var datePattern = "(".concat(numbers, "Y)?(").concat(numbers, "M)?(").concat(numbers, "W)?(").concat(numbers, "D)?");
var timePattern = "T(".concat(fractionalNumbers, "H)?(").concat(fractionalNumbers, "M)?(").concat(fractionalNumbers, "S)?");
var iso8601 = "P(?:".concat(datePattern, "(?:").concat(timePattern, ")?)");
var objMap = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
];
var defaultDuration = Object.freeze({
    years: 0,
    months: 0,
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
});
/**
 * The ISO8601 regex for matching / testing durations
 */
exports.uj = new RegExp(iso8601);
/** Parse PnYnMnDTnHnMnS format to object */
var parse = function (durationString) {
    var matches = durationString.replace(/,/g, ".").match(exports.uj);
    if (!matches) {
        throw new RangeError("invalid duration: ".concat(durationString));
    }
    // Slice away first entry in match-array (the input string)
    var slicedMatches = matches.slice(1);
    if (slicedMatches.filter(function (v) { return v != null; }).length === 0) {
        throw new RangeError("invalid duration: ".concat(durationString));
    }
    // Check only one fraction is used
    if (slicedMatches.filter(function (v) { return /\./.test(v || ""); }).length > 1) {
        throw new RangeError("only the smallest unit can be fractional");
    }
    return slicedMatches.reduce(function (prev, next, idx) {
        prev[objMap[idx]] = parseFloat(next || "0") || 0;
        return prev;
    }, {});
};
exports.Qc = parse;
/** Convert ISO8601 duration object to an end Date. */
var end = function (durationInput, startDate) {
    if (startDate === void 0) { startDate = new Date(); }
    var duration = Object.assign({}, defaultDuration, durationInput);
    // Create two equal timestamps, add duration to 'then' and return time difference
    var timestamp = startDate.getTime();
    var then = new Date(timestamp);
    then.setFullYear(then.getFullYear() + duration.years);
    then.setMonth(then.getMonth() + duration.months);
    then.setDate(then.getDate() + duration.days);
    // set time as milliseconds to get fractions working for minutes/hours
    var hoursInMs = duration.hours * 3600 * 1000;
    var minutesInMs = duration.minutes * 60 * 1000;
    then.setMilliseconds(then.getMilliseconds() + duration.seconds * 1000 + hoursInMs + minutesInMs);
    // Special case weeks
    then.setDate(then.getDate() + duration.weeks * 7);
    return then;
};
exports.ut = end;
/** Convert ISO8601 duration object to seconds */
var toSeconds = function (durationInput, startDate) {
    if (startDate === void 0) { startDate = new Date(); }
    var duration = Object.assign({}, defaultDuration, durationInput);
    var timestamp = startDate.getTime();
    var now = new Date(timestamp);
    var then = (0, exports.ut)(duration, now);
    var seconds = (then.getTime() - now.getTime()) / 1000;
    return seconds;
};
exports.my = toSeconds;
__webpack_unused_export__ = {
    end: exports.ut,
    toSeconds: exports.my,
    pattern: exports.uj,
    parse: exports.Qc,
};


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 34183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(10114);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ContentSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68251);
/* harmony import */ var src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52178);
/* harmony import */ var src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18709);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38108);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  left: 0;\n  overflow: visible;\n  ",
        " {\n    display: flex;\n    justify-content: center;\n\n    .swiper-wrapper {\n      width: max-content;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledSwiper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t).withConfig({
    displayName: "ContentSwiper__StyledSwiper",
    componentId: "sc-6f9c2f7b-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ContentSwiper = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), swiper = ref[0], setSwiper = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSwiper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        threshold: 15,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        wrapperTag: "ul",
        onSwiper: setSwiper,
        navigation: {
            prevEl: prevRef.current,
            nextEl: nextRef.current
        }
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
                theme: src_styles_theme__WEBPACK_IMPORTED_MODULE_6__/* .darkTheme */ .$_,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__/* .NavigationButton */ .W, {
                        kind: "circled",
                        ref: prevRef,
                        icon: src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_8__/* .ChevronLeft */ .s,
                        $direction: "left"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__/* .NavigationButton */ .W, {
                        kind: "circled",
                        ref: nextRef,
                        icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_9__/* .ChevronRight */ ._,
                        $direction: "right"
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 57402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ProductsLegalMentions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71008);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15201);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 21px;\n  margin-bottom: 8px;\n  max-width: 900px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 50px;\n\n  ",
        " {\n    padding-top: 90px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 20px;\n  border-top: 1rpx solid #d6d6d6;\n  ",
        " {\n    padding-top: 30px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].p.withConfig({
    displayName: "ProductsLegalMentions__Paragraph",
    componentId: "sc-5b3229a-0"
})(_templateObject());
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_4__/* .ConstraintContainer */ .a).withConfig({
    displayName: "ProductsLegalMentions__Container",
    componentId: "sc-5b3229a-1"
})(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var InnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div.withConfig({
    displayName: "ProductsLegalMentions__InnerContainer",
    componentId: "sc-5b3229a-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ProductsLegalMentions = function() {
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_7__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InnerContainer, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Paragraph, {
                    children: [
                        "*",
                        _("These class III medical devices are regulated health products which bear, under this regulation, the CE marking. Manufacturer: MATEX LAB SPA, 2 via Carlo Urbani Brindisi, Italy. Please carefully read the instructions in the leaflets. The use of these products requires the intervention of a healthcare professional.")
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Paragraph, {
                    children: [
                        "**",
                        _("These class: IIb for Sectum, IIa for Zaffiro, IIb for Plasma IQ, Medical Devices are regulated health products which bear, under this regulation, the CE mark. Manufacturer: B&K, Domaniewska 37, Warsaw, Poland. Please carefully read the instructions in the leaflets. The use of these products requires the intervention of a healthcare professional.")
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Paragraph, {
                    children: [
                        "***",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__/* .Markdown */ .U, {
                            children: _("Neauvia Cosmeceuticals are cosmetic products according to Regulation 1223/2009")
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 10114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/about-us/graphql/aboutus.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query {\n    aboutUs {\n      aboutVideos {\n        id\n        videos_id {\n          id\n          slug\n          thumbnail {\n            id\n          }\n          tags {\n            tags_id {\n              id\n              translations {\n                name\n                languages_code {\n                  code\n                }\n              }\n            }\n          }\n          disclaimer\n          source {\n            id\n            url\n            format\n            duration\n          }\n          translations {\n            name\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n      heroVideo {\n        id\n        slug\n        thumbnail {\n          id\n        }\n        disclaimer\n        source {\n          id\n          url\n          format\n          duration\n        }\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    bannerVideo: videos(filter: { slug: { _eq: "neauvia-congress" } }) {\n      id\n      slug\n      thumbnail {\n        id\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n      }\n      translations {\n        name\n        languages_code {\n          code\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var aboutUsGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/modules/about-us/hooks/useAboutUsQuery.ts






var fetchAboutUs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(aboutUsGqlQuery)
                    ];
            }
        });
    });
    return function fetchAboutUs(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useAboutUsQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(query/* QueryKey.AboutUs */.S.AboutUs, function() {
        return fetchAboutUs(apis);
    });
};

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
;// CONCATENATED MODULE: ./src/modules/about-us/assets/banner-image.png
/* harmony default export */ var banner_image = ({"src":"/_next/static/media/banner-image.d4f97be4.png","height":400,"width":438,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAVFBMVEVMaXF3ISnprptjOjzbqZcNCwxZLCN1Pjbsvq3Fk4fzz73MiIHNjnKQWUi0fWtxHiB0Ih5wPzeTGCmCWko7IRtRDhD108OkdWnXtqmzWU6zOETqQFlcRe3JAAAAFHRSTlMAbCYa/P7+/ij2uNn8/v76hNDrRllTXGQAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAA9SURBVAiZFcrbFoAQFADRUTgpXYgK//+frfM0D3twJT4rgCv7G2bA++OzC5BEbJiAW8626WNqvVTIoxvtDzvfAdOl8KklAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsBanner.tsx

function AboutUsBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 29px;\n  text-transform: uppercase;\n  color: ",
        ";\n  max-width: 230px;\n  margin-left: max(10vw, 120px);\n\n  ",
        " {\n    max-width: 820px;\n    font-size: 50px;\n    line-height: 70px;\n  }\n"
    ]);
    AboutUsBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  height: 235px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n\n  ",
        " {\n    height: 400px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -20px;\n  left: -56px;\n  width: 261px;\n  height: 275px;\n  ",
        " {\n    top: -30px;\n    left: 0;\n    width: 438px;\n    height: 462px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var Header = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "AboutUsBanner__Header",
    componentId: "sc-87066df9-0"
})(AboutUsBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsBanner__Container",
    componentId: "sc-87066df9-1"
})(_templateObject1(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.palette.background;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var BannerImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsBanner__BannerImage",
    componentId: "sc-87066df9-2"
})(_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsBanner = function(param) {
    var titleMsgId = param.titleMsgId;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: banner_image,
                        quality: 100,
                        objectFit: "contain",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _(titleMsgId)
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsNeedleHeading.tsx

function AboutUsNeedleHeading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 29px;\n  text-transform: uppercase;\n  color: ",
        ";\n  max-width: 280px;\n\n  ",
        " {\n    max-width: 820px;\n    font-size: 50px;\n    line-height: 70px;\n  }\n"
    ]);
    AboutUsNeedleHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsNeedleHeading_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  height: 285px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ",
        " {\n    height: 588px;\n  }\n"
    ]);
    AboutUsNeedleHeading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsNeedleHeading_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  clip-path: polygon(0 0, 40% 0, 100% 100%, 97% 100%);\n  width: 45px;\n  height: 100%;\n  top: 0;\n  right: 15px;\n  z-index: 0;\n\n  ",
        " {\n    width: 111px;\n    height: 100%;\n    right: 57px;\n    bottom: 0;\n  }\n  ",
        " {\n    clip-path: polygon(60% 0, 100% 0, 10% 100%, 0 100%);\n    left: 15px;\n    right: auto;\n    ",
        " {\n      left: 57px;\n    }\n  }\n"
    ]);
    AboutUsNeedleHeading_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var AboutUsNeedleHeading_Header = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "AboutUsNeedleHeading__Header",
    componentId: "sc-d67e7e72-0"
})(AboutUsNeedleHeading_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsNeedleHeading_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsNeedleHeading__Container",
    componentId: "sc-d67e7e72-1"
})(AboutUsNeedleHeading_templateObject1(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.palette.background;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Needle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsNeedleHeading__Needle",
    componentId: "sc-d67e7e72-2"
})(AboutUsNeedleHeading_templateObject2(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.palette.contrastToBackground;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsNeedleHeading = function(param) {
    var msgId = param.msgId;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsNeedleHeading_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Needle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsNeedleHeading_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _(msgId)
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/player/index.tsx + 30 modules
var player = __webpack_require__(44732);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsBannerVideo.tsx

function AboutUsBannerVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    AboutUsBannerVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsBannerVideo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    AboutUsBannerVideo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "AboutUsBannerVideo__Section",
    componentId: "sc-d1d22fd8-0"
})(AboutUsBannerVideo_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.accent;
});
var AboutUsBannerVideo_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "AboutUsBannerVideo__Container",
    componentId: "sc-d1d22fd8-1"
})(AboutUsBannerVideo_templateObject1(), (0,common.ar)(16 / 9, "max(20vw, calc(100vh - var(--header-static-height) - 130px))"));
var AboutUsBannerVideo = function(param) {
    var video = param.video;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: video && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsBannerVideo_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* NeauviaPlayerLayer */.jT, {
                    autoPlay: false,
                    video: video
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/components/shared/AboutUsHeading.tsx

function AboutUsHeading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  line-height: 29px;\n  font-weight: 300;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 32px;\n    line-height: 36px;\n  }\n"
    ]);
    AboutUsHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var AboutUsHeading = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "AboutUsHeading",
    componentId: "sc-4881585a-0"
})(AboutUsHeading_templateObject(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.palette.accent;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);

;// CONCATENATED MODULE: ./src/modules/about-us/components/shared/AboutUsSection.tsx

function AboutUsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    AboutUsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var AboutUsSection = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).attrs({
    as: "section"
}).withConfig({
    displayName: "AboutUsSection",
    componentId: "sc-49282732-0"
})(AboutUsSection_templateObject(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.primary;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);

// EXTERNAL MODULE: ./src/components/common/Swipers/ContentSwiper.tsx
var ContentSwiper = __webpack_require__(77314);
;// CONCATENATED MODULE: ./src/components/common/Swipers/ThumbnailSwiper.tsx

function ThumbnailSwiper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .swiper-slide {\n    width: 264px;\n    margin-right: 20px;\n  }\n"
    ]);
    ThumbnailSwiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ThumbnailSwiper = (0,styled_components_browser_esm["default"])(ContentSwiper/* ContentSwiper */.o).withConfig({
    displayName: "ThumbnailSwiper",
    componentId: "sc-76e62e2c-0"
})(ThumbnailSwiper_templateObject());

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/modules/materials/components/Thumbnail/index.tsx + 6 modules
var Thumbnail = __webpack_require__(87847);
;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsNeauviachannel/AboutUsVideos.tsx

function AboutUsVideos_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n\n  ",
        " {\n    margin-top: 60px;\n    margin-right: calc(-1 * var(--constraint-container-right-inner-margin));\n    margin-left: calc(-1 * var(--constraint-container-left-inner-margin));\n  }\n"
    ]);
    AboutUsVideos_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var AboutUsVideos_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsVideos__Container",
    componentId: "sc-2c8ba4a5-0"
})(AboutUsVideos_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsVideos = function(param) {
    var videos = param.videos;
    if (!videos || videos.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsVideos_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailSwiper, {
            children: videos.map(function(v) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                    tag: "li",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* Thumbnail */.$, {
                        item: v.videos_id
                    })
                }, v.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsNeauviachannel/index.tsx

function AboutUsNeauviachannel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 16px;\n"
    ]);
    AboutUsNeauviachannel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsNeauviachannel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 22px;\n  margin-bottom: 50px;\n\n  ",
        " {\n    margin-top: 72px;\n    margin-bottom: 86px;\n  }\n"
    ]);
    AboutUsNeauviachannel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsNeauviachannel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 670px;\n  margin: 16px auto 0;\n  & + & {\n    margin-top: 32px;\n  }\n"
    ]);
    AboutUsNeauviachannel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "AboutUsNeauviachannel__Description",
    componentId: "sc-5c673455-0"
})(AboutUsNeauviachannel_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.gray3;
});
var AboutUsNeauviachannel_Container = (0,styled_components_browser_esm["default"])(AboutUsSection).withConfig({
    displayName: "AboutUsNeauviachannel__Container",
    componentId: "sc-5c673455-1"
})(AboutUsNeauviachannel_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var InnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsNeauviachannel__InnerContainer",
    componentId: "sc-5c673455-2"
})(AboutUsNeauviachannel_templateObject2());
var AboutUsNeauviachannel = function(param) {
    var videos = param.videos;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsNeauviachannel_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHeading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("NEAUVIABILITY")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("Neauvia reason for being and commitment has 3 basic pillars: Science, Disruption and Lifestyle. Neauvia aims to provide a disruptive approach and solutions to the aesthetic market, always backed up by Science and Clinical Data, and by developing an iconic brand appealing to consumers.")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHeading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("PEG-HA FILLERS")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("Neauvia fillers are based on a unique SMART CROSSLINKING TECHNOLOGY – SXT – using PEG as a crosslinking agent, that provides unique properties and safety profile to NEAUVIA PEG-HA gels.")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHeading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("ADVANCED HOLISTIC APPROACH")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("Thanks to PEG-HA gels specific properties, and in line with a unique holistic vision of Aesthetics, NEAUVIA Research & Development investigated combined anti-aging therapies including Medical Devices, Energy Based Devices and Cosmeceuticals. Through synergistic protocols, NEAUVIA ADVANCED HOLISTIC APPROACH demonstrates today amplified rejuvenation outcomes for patients worldwide.")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsVideos, {
                videos: videos
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/components/common/DispatchOnClick.tsx
var DispatchOnClick = __webpack_require__(94565);
;// CONCATENATED MODULE: ./src/modules/about-us/components/shared/AboutUsContactButton.tsx

function AboutUsContactButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    max-width: 194px;\n  }\n"
    ]);
    AboutUsContactButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).attrs({
    forwardedAs: "a"
}).withConfig({
    displayName: "AboutUsContactButton__StyledButton",
    componentId: "sc-45fa3dbd-0"
})(AboutUsContactButton_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsContactButton = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchOnClick/* DispatchOnClick */.Q, {
        type: "modalOpen",
        payload: {
            kind: "contact"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
            children: _("Contact us")
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/assets/neauvia-map.png
/* harmony default export */ var neauvia_map = ({"src":"/_next/static/media/neauvia-map.f93ce6a4.png","height":501,"width":889,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEVMaXHTL1fVrLTQGUfUQVjRUXHSJE7THkrPDj/TFULPCDrSHkvTHkrRT2/UlaTTz9DT1dXZSmjSZX/Uub/Z//bHWyZ/AAAAFXRSTlMAGRW+B81JXvJzhDskkUpui2zOrigwiMx8AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAALklEQVQImQXBBwIAEAwAsaNo7fn/t0rQfX0txWHysplAVk6MCeh1TdTB8CGQ2gccmwEkREPYHAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsMap.tsx

function AboutUsMap_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas:\n    'heading'\n    'map'\n    'description';\n  margin-bottom: 32px;\n\n  ",
        " {\n    grid-template-areas:\n      'heading map'\n      'description map';\n    grid-template-columns: 'auto auto';\n\n    margin-bottom: 107px;\n  }\n"
    ]);
    AboutUsMap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsMap_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: heading;\n  margin-bottom: 41px;\n\n  ",
        " {\n    margin-bottom: 0;\n    width: 302px;\n  }\n"
    ]);
    AboutUsMap_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsMap_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0;\n\n  ",
        " {\n    max-width: 302px;\n    margin: 32px 0;\n  }\n"
    ]);
    AboutUsMap_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n\n  ",
        " {\n    justify-content: flex-end;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n\n  ",
        " {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: map;\n  position: relative;\n  height: 200px;\n  width: 100%;\n\n  ",
        " {\n    width: 713px;\n    height: 395px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: description;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var AboutUsMap_Container = (0,styled_components_browser_esm["default"])(AboutUsSection).withConfig({
    displayName: "AboutUsMap__Container",
    componentId: "sc-fb69d642-0"
})(AboutUsMap_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledHeading = (0,styled_components_browser_esm["default"])(AboutUsHeading).withConfig({
    displayName: "AboutUsMap__StyledHeading",
    componentId: "sc-fb69d642-1"
})(AboutUsMap_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsMap_Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsMap__Description",
    componentId: "sc-fb69d642-2"
})(AboutUsMap_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsMap__DescriptionWrapper",
    componentId: "sc-fb69d642-3"
})(_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsMap__HeaderWrapper",
    componentId: "sc-fb69d642-4"
})(_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsMap__ImageContainer",
    componentId: "sc-fb69d642-5"
})(_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var DescriptionArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsMap__DescriptionArea",
    componentId: "sc-fb69d642-6"
})(_templateObject6());
var AboutUsMap = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsMap_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _("Neauvia in the world")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionArea, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsMap_Description, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: _("Established in 2012 as a scientifically-based medical aesthetics company, NEAUVIA has evolved into a vibrant, high-growth multinational corporation with production sites and subsidiaries in Italy, Switzerland, France, Spain, Germany, United-Kingdom, Poland and U.S.")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsContactButton, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: neauvia_map,
                    quality: 90,
                    objectFit: "contain",
                    layout: "fill"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/assets/facilities/map.png
/* harmony default export */ var map = ({"src":"/_next/static/media/map.6e860fce.png","height":1318,"width":1528,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEX////mjqTwr8Diaon88PPOD0DleJTQGknVKFT42uHcVHfnhp/yv8z54uj99vjzydTsnLC7GY+pAAAACXBIWXMAABYlAAAWJQFJUiTwAAAANUlEQVQImQXBgQHAIAgEsQORB221+0/bhN1fR69CBuFZlEMvTS6HJ21ABFa5OdDSnAznLUk/KeIBRXQS4IEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/modules/about-us/assets/facilities/matexlab.png
/* harmony default export */ var matexlab = ({"src":"/_next/static/media/matexlab.48694584.png","height":121,"width":244,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX///////////////////////////////////8HBRbfAAAACXRSTlMmATQMjkQVp0WCdh4fAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJElEQVQImRXGwREAIBDCwACnZ/8VO+Sz4c1VYyc1AD7YuBvpAwW0AD+T7pBHAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/about-us/assets/facilities/berger-and-kraft.png
/* harmony default export */ var berger_and_kraft = ({"src":"/_next/static/media/berger-and-kraft.cb6ae55e.png","height":134,"width":166,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJFBMVEX////////////////////////////////////////////////Vd7HLAAAADHRSTlMBLRpNDiDcimCjwftqZuUAAAAACXBIWXMAABYlAAAWJQFJUiTwAAAALklEQVQImSXKNwIAIAzDQDtOA/7/X5qmGwQSP6WaQYcyi+aA1jC7YM/yeFfIDjYOhACSCO5p2gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/modules/about-us/assets/facilities/lem.png
/* harmony default export */ var lem = ({"src":"/_next/static/media/lem.0d96e2eb.png","height":84,"width":220,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEX///////////////////////+65XQCAAAABnRSTlMzAR4/Iw4XyINFAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVQImRXBgQ0AMAgDIKr1/5eXgWg+p7OM20IeAjwAKNdWz1QAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsFacilities.tsx

function AboutUsFacilities_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  padding: 0 0 60px;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 90px 0;\n  }\n"
    ]);
    AboutUsFacilities_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsFacilities_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  padding: 0;\n  ",
        " {\n    gap: 80px;\n    flex-direction: row;\n    align-items: center;\n    & > ",
        " {\n      max-width: 420px;\n      padding-left: 0;\n    }\n  }\n"
    ]);
    AboutUsFacilities_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsFacilities_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    AboutUsFacilities_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboutUsFacilities_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0;\n\n  ",
        " {\n    margin: 28px 0;\n  }\n"
    ]);
    AboutUsFacilities_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AboutUsFacilities_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 323px;\n\n  ",
        " {\n    width: 764px;\n    height: 659px;\n  }\n"
    ]);
    AboutUsFacilities_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AboutUsFacilities_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  ",
        " {\n    margin-top: 40px;\n  }\n"
    ]);
    AboutUsFacilities_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AboutUsFacilities_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  ",
        " {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n  }\n"
    ]);
    AboutUsFacilities_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 75%;\n  font-size: 12px;\n  line-height: 18px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 21px;\n  font-weight: 500;\n\n  margin-bottom: 8px;\n  ",
        " {\n    margin-top: 18px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 120px;\n  height: 70px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}















var AboutUsFacilities_Container = (0,styled_components_browser_esm["default"])(AboutUsSection).withConfig({
    displayName: "AboutUsFacilities__Container",
    componentId: "sc-ab212b45-0"
})(AboutUsFacilities_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "AboutUsFacilities__ContentContainer",
    componentId: "sc-ab212b45-1"
})(AboutUsFacilities_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, ConstraintContainer/* ConstraintContainer */.a);
var AboutUsFacilities_StyledHeading = (0,styled_components_browser_esm["default"])(AboutUsHeading).withConfig({
    displayName: "AboutUsFacilities__StyledHeading",
    componentId: "sc-ab212b45-2"
})(AboutUsFacilities_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var AboutUsFacilities_Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsFacilities__Description",
    componentId: "sc-ab212b45-3"
})(AboutUsFacilities_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsFacilities_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsFacilities__ImageContainer",
    componentId: "sc-ab212b45-4"
})(AboutUsFacilities_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Facilities = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsFacilities__Facilities",
    componentId: "sc-ab212b45-5"
})(AboutUsFacilities_templateObject5(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Facility = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsFacilities__Facility",
    componentId: "sc-ab212b45-6"
})(AboutUsFacilities_templateObject6(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var FacilityContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsFacilities__FacilityContent",
    componentId: "sc-ab212b45-7"
})(_templateObject7());
var Name = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "AboutUsFacilities__Name",
    componentId: "sc-ab212b45-8"
})(_templateObject8(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var FacilityImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsFacilities__FacilityImage",
    componentId: "sc-ab212b45-9"
})(_templateObject9());
var facilities = [
    {
        title: "NEAUVIA PEG-HA FILLERS*",
        text: "VIA CARLO URBANI",
        image: matexlab
    },
    {
        title: "NEAUVIA ENERGY BASED DEVICES**",
        text: "Berger&Kraft",
        image: berger_and_kraft
    },
    {
        title: "NEAUVIA AESTHETIC COSMECEUTICALS***",
        text: "Via Oberdan",
        image: lem
    }, 
];
var AboutUsFacilities = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsFacilities_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsFacilities_ImageContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: map,
                            quality: 90,
                            objectFit: "contain",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsFacilities_StyledHeading, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    children: _("Neauvia Facilities")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsFacilities_Description, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    children: _("NEAUVIA company is part of MATEX LAB Group and has production sites in Italy and Poland, mastering advanced in-house technologies and the production of its whole portfolio.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Facilities, {
                                children: facilities.map(function(param) {
                                    var title = param.title, text = param.text, image = param.image;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Facility, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FacilityContent, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                                        children: _(title)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                                        children: _(text)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilityImage, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: image,
                                                    quality: 90,
                                                    layout: "fill",
                                                    objectFit: "contain",
                                                    objectPosition: "0 50%"
                                                })
                                            })
                                        ]
                                    }, title);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/assets/models.jpg
/* harmony default export */ var models = ({"src":"/_next/static/media/models.c9d6bc2f.jpg","height":730,"width":460,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAEAAgEFAAAAAAAAAAAAAAABAAIRAwUGFFH/xAAVAQEBAAAAAAAAAAAAAAAAAAACBf/EABsRAAIBBQAAAAAAAAAAAAAAAAABAhITIWGR/9oADAMBAAIRAxEAPwCDpc73KivZxZAtmo+xEQKGyxcisULh/9k=","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsHolisticVision.tsx

function AboutUsHolisticVision_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 19px 0 35px;\n  width: 198px;\n\n  ",
        " {\n    width: 304px;\n    margin: 32px 0;\n  }\n  ",
        " {\n    min-height: 174px;\n  }\n"
    ]);
    AboutUsHolisticVision_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsHolisticVision_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  top: -30px;\n  ",
        " {\n    left: 0;\n    right: auto;\n  }\n\n  ",
        " {\n    position: relative;\n    bottom: 40px;\n  }\n"
    ]);
    AboutUsHolisticVision_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsHolisticVision_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 136px;\n  height: 294px;\n\n  ",
        " {\n    width: 379px;\n    height: 601px;\n  }\n"
    ]);
    AboutUsHolisticVision_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboutUsHolisticVision_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    AboutUsHolisticVision_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AboutUsHolisticVision_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  object-position: 70% center;\n"
    ]);
    AboutUsHolisticVision_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AboutUsHolisticVision_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 198px;\n\n  ",
        " {\n    width: 304px;\n  }\n"
    ]);
    AboutUsHolisticVision_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AboutUsHolisticVision_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    width: 100%;\n    margin-top: 35px;\n  }\n\n  ",
        " {\n    position: relative;\n    margin: 0 177px 0 0;\n    ",
        " {\n      margin: 0 0 0 177px;\n    }\n  }\n"
    ]);
    AboutUsHolisticVision_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}











var AboutUsHolisticVision_Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsHolisticVision__Description",
    componentId: "sc-a3ba6128-0"
})(AboutUsHolisticVision_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsHolisticVision__ImageWrapper",
    componentId: "sc-a3ba6128-1"
})(AboutUsHolisticVision_templateObject1(), theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsHolisticVision_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsHolisticVision__ImageContainer",
    componentId: "sc-a3ba6128-2"
})(AboutUsHolisticVision_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AboutUsHolisticVision_Container = (0,styled_components_browser_esm["default"])(AboutUsSection).withConfig({
    displayName: "AboutUsHolisticVision__Container",
    componentId: "sc-a3ba6128-3"
})(AboutUsHolisticVision_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "AboutUsHolisticVision__StyledImage",
    componentId: "sc-a3ba6128-4"
})(AboutUsHolisticVision_templateObject4());
var AboutUsHolisticVision_StyledHeading = (0,styled_components_browser_esm["default"])(AboutUsHeading).withConfig({
    displayName: "AboutUsHolisticVision__StyledHeading",
    componentId: "sc-a3ba6128-5"
})(AboutUsHolisticVision_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var TextContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AboutUsHolisticVision__TextContent",
    componentId: "sc-a3ba6128-6"
})(AboutUsHolisticVision_templateObject6(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX);
var AboutUsHolisticVision = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsHolisticVision_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHolisticVision_StyledHeading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("ABOUT NEAUVIA CHANNEL")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHolisticVision_Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: _("On this platform you will find all NEAUVIA scientific on-line trainings and exclusive Prime Time Talk Show. You also have the possibility to chat with NEAUVIA Experts via the CONTACT US section.")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsContactButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHolisticVision_ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: models,
                        layout: "fill"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/about-us/components/AboutUsHeroVideo.tsx

function AboutUsHeroVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    AboutUsHeroVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AboutUsHeroVideo_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "AboutUsHeroVideo__Container",
    componentId: "sc-d0122452-0"
})(AboutUsHeroVideo_templateObject(), (0,common.ar)(16 / 9, "max(20vw, calc(100vh - var(--header-static-height) - 130px))"));
var AboutUsHeroVideo = function(param) {
    var heroVideo = param.heroVideo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: heroVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHeroVideo_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* NeauviaPlayerLayer */.jT, {
                video: heroVideo,
                autoPlay: false
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/seo/MetaTitle.tsx
var MetaTitle = __webpack_require__(71508);
// EXTERNAL MODULE: ./src/components/seo/MetaDescription.tsx
var MetaDescription = __webpack_require__(89080);
// EXTERNAL MODULE: ./src/modules/products/components/ProductsLegalMentions.tsx
var ProductsLegalMentions = __webpack_require__(57402);
;// CONCATENATED MODULE: ./src/pages/about-us.tsx














var AboutUsPage = function() {
    var ref, ref1;
    var data = useAboutUsQuery().data;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTitle/* MetaTitle */.p, {
                children: _("Company Information, Neauvia in the World")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaDescription/* MetaDescription */.l, {
                children: _("NEAUVIA’s mission is to empower people to proactively, holistically & effectively take control of their ageing process from the inside-out")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsBanner, {
                titleMsgId: "Neauvia provides a disruptive approach and products to the aesthetic market"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsBannerVideo, {
                video: data === null || data === void 0 ? void 0 : data.bannerVideo[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsNeauviachannel, {
                videos: data === null || data === void 0 ? void 0 : (ref = data.aboutUs) === null || ref === void 0 ? void 0 : ref.aboutVideos
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsMap, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsFacilities, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHeroVideo, {
                heroVideo: data === null || data === void 0 ? void 0 : (ref1 = data.aboutUs) === null || ref1 === void 0 ? void 0 : ref1.heroVideo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsNeedleHeading, {
                msgId: "THE FIRST 24/7 AESTHETIC MEDICINE CHANNEL DEDICATED TO DOCTORS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHolisticVision, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsLegalMentions/* ProductsLegalMentions */.z, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var about_us = (AboutUsPage);


/***/ }),

/***/ 35800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5689,78,8281,4732,9774,2888,179], function() { return __webpack_exec__(34183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);